import React from 'react';
import DOMPurify from 'dompurify';
import styles from './StepThree.module.css';

import glassRailingImage from '../assets/images/glass_railing.webp';
import picketRailingImage from '../assets/images/picket_railing.webp';

const StepThree = ({ formData, handleInputChange, errors }) => {
  
  const handleSanitizedInputChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value);
    handleInputChange({
      target: {
        name: e.target.name,
        value: sanitizedValue,
      },
    });
  };

  const handleKeyDown = (event, value) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      if (value === 'Glass') {
        handleSanitizedInputChange({ target: { name: 'railingType', value: 'Picket' } });
      }
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      if (value === 'Picket') {
        handleSanitizedInputChange({ target: { name: 'railingType', value: 'Glass' } });
      }
    }
  };

  return (
    <div className={styles.stepThreeContainer}>
      <h2>Step 3: Select Railing Type</h2>
      <div className={styles.railingOptions}>
        <label className={styles.railingOption}>
          <input
            type="radio"
            name="railingType"
            value="Glass"
            checked={formData.railingType === 'Glass'}
            onChange={handleSanitizedInputChange}
            aria-labelledby="glass-railing"
            aria-describedby="railing-description"
            style={{ display: 'none' }}
          />
          <div className={`${styles.railingImageContainer} ${formData.railingType === 'Glass' ? styles.selected : ''}`}>
            <img 
              src={glassRailingImage} 
              alt="Glass Railing" 
              className={styles.railingImage}
            />
          </div>
          <span
            id="glass-railing"
            className={styles.railingLabel}
            onKeyDown={(event) => handleKeyDown(event, 'Glass')}
            tabIndex={0}
          >
            Glass Railing
          </span>
        </label>
        <label className={styles.railingOption}>
          <input
            type="radio"
            name="railingType"
            value="Picket"
            checked={formData.railingType === 'Picket'}
            onChange={handleSanitizedInputChange}
            aria-labelledby="picket-railing"
            aria-describedby="railing-description"
            style={{ display: 'none' }}
          />
          <div className={`${styles.railingImageContainer} ${formData.railingType === 'Picket' ? styles.selected : ''}`}>
            <img 
              src={picketRailingImage} 
              alt="Picket Railing" 
              className={styles.railingImage}
            />
          </div>
          <span
            id="picket-railing"
            className={styles.railingLabel}
            onKeyDown={(event) => handleKeyDown(event, 'Picket')}
            tabIndex={0}
          >
            Picket Railing
          </span>
        </label>
      </div>
      {errors.railingType && <p className={styles.error}>{errors.railingType}</p>}
    </div>
  );
};

export default StepThree;